<template>
  <div>
    <el-row type="flex" justify="space-between" align="middle">
      <el-col :span="1">
        <el-button
          @click="onMenuToggleClick"
          class="menu-button"
          type="primary"
          icon="el-icon-menu"
          circle
        ></el-button>
      </el-col>
      <el-col :span="15">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">{{
            appName
          }}</el-breadcrumb-item>
          <el-breadcrumb-item v-if="breadcrumbCategory">{{
            breadcrumbCategory
          }}</el-breadcrumb-item>
          <el-breadcrumb-item v-if="breadcrumbView">{{
            breadcrumbView
          }}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
      <el-col :span="8" style="text-align: right;">
        <span class="menu-version"
          >{{ webVersion }} / {{ serverVersion.version }} /
          {{ apiVersion.version }}</span
        >
        <el-dropdown @command="handleCommand">
          <el-button
            class="menu-button"
            type="primary"
            icon="el-icon-user-solid"
            circle
          ></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item disabled>
              {{ $t("common.menu.user.currentUser") }}:
              {{ user.login }}
            </el-dropdown-item>
            <el-dropdown-item disabled>
              {{ $t("common.menu.user.currentConnection") }}:
              {{ base.label }}
            </el-dropdown-item>
            <el-dropdown-item icon="el-icon-info" command="about">
              {{ $t("common.menu.user.about") }}
            </el-dropdown-item>
            <el-dropdown-item icon="el-icon-setting" command="setting">
              {{ $t("common.menu.user.settings") }}
            </el-dropdown-item>
            <el-dropdown-item icon="el-icon-switch-button" command="signOut">
              {{ $t("common.menu.user.signOut") }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { version } from "@/mixins/version";

export default {
  name: "menuhorizontal",
  mixins: [version],
  computed: {
    ...mapGetters(["serverVersion", "apiVersion", "user", "base"]),
    breadcrumbCategory: function() {
      let result;

      switch (this.$route.name) {
        case "enteringpayments":
        case "enteringsubsidies":
          result = this.$t("common.menu.massinput.name");
          break;
        case "errorpayments":
          result = this.$t("common.menu.searchchange.name");
          break;
        case "bankpay":
        case "packsreceipts":
        case "relationship":
        case "assignoperators":
        case "controlpacks":
        case "controlinetpays":
          result = this.$t("common.menu.paymentdocuments.name");
          break;
        default:
          result = "";
      }
      return result;
    },
    breadcrumbView: function() {
      let result;

      switch (this.$route.name) {
        case "enteringpayments":
          result = this.$t("common.menu.massinput.enteringPayments.name");
          break;
        case "enteringsubsidies":
          result = this.$t("common.menu.massinput.enteringSubsidies.name");
          break;
        case "subscribers":
          result = this.$t("common.menu.subscribers.name");
          break;
        case "errorpayments":
          result = this.$t("common.menu.searchchange.errorpayments.name");
          break;
        case "bankpay":
          result = this.$t("common.menu.paymentdocuments.bankPay.name");
          break;
        case "packsreceipts":
          result = this.$t("common.menu.paymentdocuments.packsReceipts.name");
          break;
        case "relationship":
          result = this.$t("common.menu.paymentdocuments.relationship.name");
          break;
        case "assignoperators":
          result = this.$t("common.menu.paymentdocuments.assignOperators.name");
          break;
        case "controlpacks":
          result = this.$t("common.menu.paymentdocuments.controlPacks.name");
          break;
        case "controlinetpays":
          result = this.$t("common.menu.paymentdocuments.controlInetPays.name");
          break;
        case "reports":
          result = this.$t("common.menu.reports.name");
          break;
        case "acceptedshipment":
          result = this.$t("common.menu.acceptedshipment.name");
          break;
        case "settings":
          result = this.$t("common.menu.settings.name");
          break;
        default:
          result = "";
      }
      return result;
    }
  },
  methods: {
    ...mapActions(["signOut"]),
    onMenuToggleClick() {
      this.$emit("menuToggle");
    },
    handleCommand(command) {
      switch (command) {
        case "about":
          this.$emit("menuAbout");
          break;
        case "setting":
          this.$router.push("/settings");
          break;
        case "signOut":
          this.signOut();
          break;
      }
    }
  }
};
</script>

<style scoped>
.menu-version {
  margin-right: 0.5em;
}
.menu-button {
  border: none;
}
.el-dropdown-menu {
  background-color: #90b4ce;
  border-color: #90b4ce;
}
.el-dropdown-menu__item.is-disabled {
  color: #d7e7d4;
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #7390a5;
  color: #303133;
}
</style>

<style>
.el-dropdown-menu .popper__arrow::after {
  border-bottom-color: #90b4ce !important;
}
</style>
